/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDBadge from "components/MDBadge";

// Images
import team2 from "assets/images/team-2.jpg";
import team3 from "assets/images/team-3.jpg";
import team4 from "assets/images/team-4.jpg";
import DataTable from "examples/Tables/DataTable";
import { Icon } from "@mui/material";
import colors from "assets/theme/base/colors";

export default function data({ tags = [], onRemove, isMyProfile = true }) {
  return (
    <MDBox pt={2} display="flex" flexWrap="wrap" gap={1}>
      {tags.map((tag) => (
        <MDBox
          key={tag}
          bgColor={colors.lightGreen.main}
          p={2}
          borderRadius="15px"
          display="flex"
          alignItems="center"
          justifyContent="center"
          sx={{ height: 20 }}
          gap={2}
        >
          <MDTypography variant="caption" fontWeight="regular" color={colors.success.main}>
            {tag}
          </MDTypography>
          {isMyProfile && (
            <MDBox
              display="flex"
              alignItems="center"
              justifyContent="center"
              // bgColor={colors.success.main}
              // borderRadius="15px"
            >
              <Icon fontSize="small" sx={{ color: colors.grey[600], cursor: "pointer" }}>
                cancel
              </Icon>
            </MDBox>
          )}
        </MDBox>
      ))}
    </MDBox>
  );
}
